import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'

const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr
  },
  missingWarn: true,
  fallbackWarn: true,
  silentTranslationWarn: false,
  silentFallbackWarn: false,
  formatFallbackMessages: true,
  allowComposition: true,
  globalInjection: true,
  runtimeOnly: true,
  escapeParameter: true,
  sync: true,
  pluralizationRules: {
    fr: (choice: number) => (choice > 1 ? 1 : 0)
  },
  numberFormats: {
    fr: {
      currency: {
        style: 'currency',
        currency: 'EUR'
      }
    }
  },
  dateTimeFormats: {
    fr: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }
    }
  }
})

i18n.global.locale.value = 'fr'
document.documentElement.setAttribute('lang', 'fr')

export default i18n
